// extracted by mini-css-extract-plugin
export default {"container":"DateNavigatorWeekSelector_container__SsWZV","button":"DateNavigatorWeekSelector_button__Wgwno","icon":"DateNavigatorWeekSelector_icon__j9Mcb"};